// LogInWithCode logs in a user with a CO code & state.
export const AuthenticationService_LogInWithCodeLazy = () =>
  import("./service.grpc").then((m) => m.AuthenticationService_LogInWithCode);
AuthenticationService_LogInWithCodeLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/LogInWithCode" as const;

// GetSSOButtons gets the available SSO buttons for the given config.
export const AuthenticationService_GetSSOButtonsLazy = () =>
  import("./service.grpc").then((m) => m.AuthenticationService_GetSSOButtons);
AuthenticationService_GetSSOButtonsLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/GetSSOButtons" as const;
